<template>
  <FormGroup :error-container="errorContainer" label="Residential Status" name="residentialStatus" :floating="floating">
    <FmSelect :value="value" :options="options" :icons="icons" :disabled="disabled"
              @input="$emit('input', $event)"/>
  </FormGroup>
</template>

<script>
import ServerErrorMixin from '@modules/shared/mixins/ServerErrorMixin';
import FormGroup from '@modules/shared/components/form/FormGroup.vue';
import FmSelect from '@modules/shared/components/form/FmSelect.vue';
import {ResidentialStatus} from '@modules/guest/new-applicant/constants.js';

const ICONS = {
  'Mortgage':             `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5z"/><path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm-2 5.5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-2z"/></svg>`,
  'Renting':              `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M0 8a4 4 0 0 1 7.465-2H14L15 7l1 1-1 1-1 1-1-1-1 1-1-1-1 1-1-1H7.465A4 4 0 0 1 0 8zm4-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/></svg>`,
  'Owned':                `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L8 2.207l6.646 6.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5z"/><path d="m8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm-4 6.5a4 4 0 0 0 2.786 3.821L7.47 12.5a3 3 0 0 1-.47-1.5v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2a3 3 0 0 1-.47 1.5l-.316 1.321A4 4 0 0 0 12 9.793V9.29l-4-4-4 4v.503z"/></svg>`,
  'Boarding':             `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5zm.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1h-4zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1h-2z"/></svg>`,
  'Living with Parents':  `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5.784 6A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z"/></svg>`,
};

export default {
  name: 'ResidentialStatusSelect',
  components: { FormGroup, FmSelect },
  mixins: [ServerErrorMixin],
  model: { prop: 'value', event: 'input' },
  props: {
    value:          { default: '' },
    disabled:       { default: false },
    errorContainer: { default: '' },
    floating:       { type: Boolean, default: false },
  },
  computed: {
    options: () => ResidentialStatus,
    icons:   () => ICONS,
  },
  watch: {
    errorContainer: {
      immediate: true,
      handler(container) { if (container) this.registerErrorContainer(container); },
    },
  },
};
</script>
